'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _classCallCheck = require('@babel/runtime-corejs3/helpers/classCallCheck');
var _createClass = require('@babel/runtime-corejs3/helpers/createClass');
var patternExpansion_model = require('./pattern-expansion.model.js');
var patternPath_model = require('./pattern-path.model.js');
var patternVertexSetOperation_model = require('./pattern-vertex-set-operation.model.js');
var patternWidget_model = require('./pattern-widget.model.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);
var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);

var PatternWidgetFactory = /*#__PURE__*/function () {
  function PatternWidgetFactory() {
    _classCallCheck__default["default"](this, PatternWidgetFactory);
  }
  return _createClass__default["default"](PatternWidgetFactory, [{
    key: "getPatternWidget",
    value: function getPatternWidget(data) {
      switch (data.type) {
        case patternWidget_model.PathType.SingleShortestPath:
        case patternWidget_model.PathType.AllShortestPaths:
        case patternWidget_model.PathType.AllPaths:
          {
            return new patternPath_model.PatternPath(data);
          }
        case patternWidget_model.ExpansionType.OneStepExpansion:
          {
            return new patternExpansion_model.PatternExpansion(data);
          }
        case patternWidget_model.VertexSetOperation.Intersect:
        case patternWidget_model.VertexSetOperation.Union:
        case patternWidget_model.VertexSetOperation.Subtract:
        case patternWidget_model.VertexSetOperation.Within:
          {
            return new patternVertexSetOperation_model.PatternVertexSetOperation(data);
          }
      }
    }
  }]);
}();

exports.PatternWidgetFactory = PatternWidgetFactory;
